import { createGlobalStyle } from 'styled-components';

export const Theme = {
  colors: {
    primary: '#0061FF',
    secondary: '#60EFFF',
    background: '#0F172A',
    surface: 'rgba(30, 41, 59, 0.7)',
    text: '#F8FAFC',
    textDim: '#94A3B8',
    glass: 'rgba(255, 255, 255, 0.05)',
    glassBorder: 'rgba(255, 255, 255, 0.12)',
    accent: '#818CF8',
    success: '#10B981',
    alert: '#EF4444',
  },
  fonts: {
    main: "'Inter', sans-serif",
    title: "'Outfit', sans-serif",
    accent: "'Bebas Neue', sans-serif",
  },
  glass: `
    backdrop-filter: blur(16px);
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.12);
    box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
  `,
  transitions: {
    soft: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  },
  breakpoints: {
    mobile: '768px',
    tablet: '1024px',
    desktop: '1280px',
  }
};

export const GlobalStyle = createGlobalStyle`

  body {
    margin: 0;
    padding: 0;
    font-family: ${Theme.fonts.main};
    background: ${Theme.colors.background};
    color: ${Theme.colors.text};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
  }

  * {
    box-sizing: border-box;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${Theme.fonts.title};
    font-weight: 600;
  }

  /* Personalización de barras de desplazamiento */
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-track {
    background: ${Theme.colors.background};
  }
  ::-webkit-scrollbar-thumb {
    background: ${Theme.colors.glassBorder};
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: ${Theme.colors.primary};
  }
`;
